// src/AvalieAppPage.jsx
//
// Página pública /avalieapp retirada do ar em 15/08/2026.
// A rota em App.js permanece para o bundle não quebrar; o 301 no
// firebase.json e este Navigate mandam o visitante para a home.
// noindex evita reindexação da URL antiga.

import React from 'react';
import { Navigate } from 'react-router-dom';
import PageSeo from './seo/PageSeo';

const AvalieAppPage = () => (
  <>
    <PageSeo
      path="/avalieapp"
      title="Consulta+"
      description="Consulta médica por chat. Orientações, receitas e atestados com médico."
      noindex
    />
    <Navigate to="/" replace />
  </>
);

export default AvalieAppPage;
